import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslocoModule} from '@jsverse/transloco';
import {IUploadFilesServiceToken, UploadFilesService} from '../../upload-files.service';
import {CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-handle-duplicates-step',
  templateUrl: './handle-duplicates-step.component.html',
  styleUrls: ['./handle-duplicates-step.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    FormsModule,
    CommonModule
  ],
  providers:[
        {
            provide: IUploadFilesServiceToken, useExisting: UploadFilesService,
        }
  ]
})
export class HandleDuplicatesStepComponent {
 
    @Input({required: true}) mergeOrganisations:boolean;

    @Output() mergeOrganisationsChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    mergeOrganisationsChanged($event: boolean) {
        this.mergeOrganisationsChange.next($event);
    }
}
